/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSettingScopeFromJSON(json) {
    return StreemApiSettingScopeFromJSONTyped(json, false);
}
export function StreemApiSettingScopeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'callSourceCodes': !exists(json, 'call_source_codes') ? undefined : json['call_source_codes'],
    };
}
export function StreemApiSettingScopeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'call_source_codes': value.callSourceCodes,
    };
}
//# sourceMappingURL=StreemApiSettingScope.js.map